import React from 'react';
import {useTranslation} from 'react-i18next';

const ReaderFilterLabel = (props) => {
  const { filteredReaders, onRemove } = props;
  const {t} = useTranslation();
  return (
    <span className='br-chip'>
      {filteredReaders.displayName}
      <button
        type='button'
        className='br-chip__remove'
        aria-label={`${t('RemoveFilter')}: ${filteredReaders.displayName}`}
        onClick={onRemove}
      >×</button>
    </span>
  );
};

export default ReaderFilterLabel;
